import { Dialog, DialogContent, TextField } from '@mui/material';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import TextInput from '@Components/DomElements/TextInput';
import ModalBody from '@Components/ModalComponents/ModalBody';
import ModalFooter from '@Components/ModalComponents/ModalFooter';
import ModalHeader from '@Components/ModalComponents/ModalHeader';
import Styles from './ContentsDrawer.scss';

const ManageFolderDialogue = (props) => {
    const { selectedFolder, isOpen, onCancel, onSubmit } = props;

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [folderName, setFolderName] = useState<string>('');

    useEffect(() => {
        const wpName = !_isNil(selectedFolder)
            ? selectedFolder.folder_name
            : '';
        setFolderName(wpName);
        setIsSubmitting(false);
    }, [isOpen]);

    const canSubmit = folderName !== '' && !isSubmitting;

    const handleSubmit = () => {
        setIsSubmitting(true);
        onSubmit(folderName, selectedFolder);
    };

    return (
        <Dialog id="manage-folder-dialogue" open={isOpen} maxWidth="md">
            <ModalHeader
                id="manage-folder-dialogue-header"
                title={`${_isNil(selectedFolder) ? 'Create' : 'Edit'} Folder`}
                onCancel={onCancel}
                isCancelDisabled={isSubmitting}
            />
            <ModalBody>
                <div className={Styles.cdManageWpContainer}>
                    <TextInput
                        id="manage-folder-dialogue-input"
                        onChange={(e) => {
                            setFolderName(e.target.value);
                        }}
                        value={folderName}
                        label="Folder Name"
                        autoFocus
                        disabled={isSubmitting}
                        placeholder="Folder Name"
                    />
                </div>
            </ModalBody>
            <ModalFooter
                id="manage-folder-footer"
                onCancel={onCancel}
                onSubmit={handleSubmit}
                canSubmit={canSubmit}
                isSubmitting={isSubmitting}
            />
        </Dialog>
    );
};

ManageFolderDialogue.propTypes = {
    selectedFolder: PropTypes.object,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    isOpen: PropTypes.bool,
};
export default ManageFolderDialogue;
